module.exports = __webpack_public_path__ + "static/img/treesoft.11ed648.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode/treesoft.png
// module id = 4XPU
// module chunks = 1